import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Camera, Link, PenTool, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface CreateOptionsOverlayProps {
  isOpen: boolean;
  onClose: () => void;
}

export function CreateOptionsOverlay({ isOpen, onClose }: CreateOptionsOverlayProps) {
  const navigate = useNavigate();

  const handleOption = (type: 'camera' | 'import' | 'write') => {
    onClose();
    switch (type) {
      case 'camera':
        navigate('/admin/feed?compose=true&mode=camera');
        break;
      case 'import':
        // Future: Open Import Modal
        navigate('/admin/feed?compose=true&mode=import');
        break;
      case 'write':
        navigate('/admin/articles/new'); 
        break;
    }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <>
           {/* Backdrop */}
           <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="fixed inset-0 bg-black/80 backdrop-blur-sm z-[290]"
          />

          <motion.div
            initial={{ opacity: 0, y: 50, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 50, scale: 0.9 }}
            className="fixed bottom-32 left-0 right-0 z-[300] flex justify-center pointer-events-none"
          >
             <div className="bg-[#0F172A] border border-white/10 rounded-2xl p-2 flex items-center gap-2 shadow-2xl pointer-events-auto">
                <button 
                    onClick={() => handleOption('write')}
                    className="flex flex-col items-center gap-1 w-20 py-3 rounded-xl hover:bg-white/5 transition-colors group"
                >
                    <div className="w-12 h-12 rounded-full bg-brand-blue-DEFAULT/20 text-brand-blue-DEFAULT flex items-center justify-center mb-1 group-hover:scale-110 transition-transform">
                        <PenTool size={20} />
                    </div>
                    <span className="text-[10px] font-bold text-white/60">Artigo</span>
                </button>

                <button 
                    onClick={() => handleOption('import')}
                    className="flex flex-col items-center gap-1 w-20 py-3 rounded-xl hover:bg-white/5 transition-colors group relative"
                >
                    <div className="w-12 h-12 rounded-full bg-purple-500/20 text-purple-400 flex items-center justify-center mb-1 group-hover:scale-110 transition-transform">
                        <Link size={20} />
                    </div>
                    <span className="text-[10px] font-bold text-white/60">Importar</span>
                    <span className="absolute -top-1 -right-1 bg-brand-gold text-brand-midnight text-[8px] font-bold px-1.5 py-0.5 rounded-full">NOVOS</span>
                </button>

                <button 
                    onClick={() => handleOption('camera')}
                    className="flex flex-col items-center gap-1 w-20 py-3 rounded-xl hover:bg-white/5 transition-colors group"
                >
                    <div className="w-12 h-12 rounded-full bg-brand-gold text-brand-midnight flex items-center justify-center mb-1 group-hover:scale-110 transition-transform shadow-glow-gold">
                        <Camera size={20} />
                    </div>
                    <span className="text-[10px] font-bold text-white/60">Câmera</span>
                </button>
             </div>
          </motion.div>

          <motion.button
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="fixed bottom-20 left-1/2 -translate-x-1/2 z-[310] flex flex-col items-center gap-1 text-white/40 hover:text-white"
          >
             <span className="p-2 bg-white/10 rounded-full">
                <X size={20} />
             </span>
             <span className="text-[10px] uppercase font-bold tracking-widest">Fechar</span>
          </motion.button>
        </>
      )}
    </AnimatePresence>
  );
}
